<template>
    <div>
        <div class="flow">

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
        created() {
            this.getUserInfo()  
        },
        methods: {
            getUserInfo() {
                this.axios.get('user_info').then(response => {
                    console.log(response);
                })
            }
        }
            
    }
</script>

<style scoped>

</style>